module.exports = __webpack_public_path__ + "img/daili.df52d0c0.png";